import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-livecasino',
  templateUrl: './livecasino.component.html',
  styleUrls: ['./livecasino.component.scss']
})
export class LivecasinoComponent implements OnInit {
  activeTab: string = 'universe-live';

  universeLiveGames = [
    '20-20 TEENPATTI', 'LUCKY 7', '1 DAY TEENPATTI', 'JOKER TEENPATTI',
    'DRAGON TIGER', 'BACCARAT', 'ANDAR BAHAR', '32 CARDS',
    'POKER', 'DTL', '1 DAY DRAGON TIGER', 'MUFLIS TEENPATTI',
    'CARD RACE', 'AMART AKBAR ANTHONY'
  ];

  universeOriginalGames = [
    'VIMAA', 'BALLON', 'HEADS & TAILS', 'LUCKY 0 TO 9'
  ];

  constructor() { }

  ngOnInit(): void {
  }
}
